import React from 'react'
import { HiOutlinePhone } from "react-icons/hi2";
import { HiOutlineMail } from "react-icons/hi";
import { SlLocationPin, SlSocialFacebook, SlSocialLinkedin, SlSocialInstagram } from "react-icons/sl";
import { Link } from 'react-router-dom';

function Contact() {
  return (
    <div className="bg-gradient-to-t from-pink-100 via-pink-50 to-pink-100">
        <div className="px-5 md:px-12 lg:px-32 xl:px-40 2xl:px-60 py-8 md:py-10 lg:py-20">
          <h2 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl poppins-bold uppercase text-center bg-pink-600 py-2 md:py-4 text-white">
            Nos contact
          </h2>

          <div class="relative">
            <div class="font-[sans-serif] text-[#333]">
              <div class="max-w-5xl mx-auto">
                <div>
                  <p className="py-5 poppins-regular text-sm sm:text-base">
                    N'hésitez pas à nous contacter pour profiter de notre devis gratuit ou pour plus d'information. Nous vous répondons dans le plus bref délais.
                  </p>
                </div>

                <div class="grid sm:grid-cols-2 items-center gap-10 lg:gap-16 my-6">
                  <div>
                    <div className="mt-2">
                      <h2 className="text-lg font-extrabold">Adresse</h2>
                      <ul className="mt-2">
                          <li className="flex items-center transition-all duration-300 hover:scale-105">
                              <div className="bg-pink-200 h-10 w-10 rounded-full flex items-center justify-center shrink-0">
                                <SlLocationPin color="#d53f8c" size={20} />
                              </div>
                              <div className="text-pink-600 text-sm ml-3">
                                  <small className="block">Adresse</small>
                                  <span className="poppins-semibold">Lot VB 3 O 22 Tongarivo Tanjombato</span>
                              </div>
                          </li>
                      </ul>
                    </div>
                    <div className="mt-4">
                      <h2 className="text-lg font-extrabold">Email</h2>
                      <ul className="mt-2">
                          <li className="flex items-center transition-all duration-300 hover:scale-105">
                              <div className="bg-pink-200 h-10 w-10 rounded-full flex items-center justify-center shrink-0">
                                <HiOutlineMail color="#d53f8c" size={20} />
                              </div>
                              <a href="mailto:bijoufifaliana.s217@gmail.com" className="text-pink-600 text-sm ml-3">
                                  <small className="block">E-mail</small>
                                  <span className="poppins-semibold">contact@ecokazafrica.com</span>
                              </a>
                          </li>
                      </ul>
                    </div>
                    <div className="mt-4">
                      <h2 className="text-lg font-extrabold">Téléphone</h2>
                      <ul className="mt-2">
                          <li className="flex items-center transition-all duration-300 hover:scale-105">
                              <div className="bg-pink-200 h-10 w-10 rounded-full flex items-center justify-center shrink-0">
                                  <HiOutlinePhone color="#d53f8c" size={20} />
                              </div>
                              <div className="text-pink-600 text-sm ml-3">
                                  <small className="block">Tel</small>
                                  <span className="poppins-semibold">+261341343601</span>
                              </div>
                          </li>
                      </ul>
                    </div>
                    <div className="mt-4">
                      <h2 className="text-lg font-extrabold">Suivez-nous sur les réseaux</h2>
                      <ul className="flex mt-2 space-x-4">
                          <li className="bg-pink-200 h-10 w-10 rounded-full flex items-center justify-center shrink-0 transition-all duration-300 hover:scale-125">
                              <Link to="https://web.facebook.com/profile.php?id=61560310173070" target='_blank'>
                                <SlSocialFacebook color='#d53f8c' size={20} />
                              </Link>
                          </li>
                      </ul>
                    </div>
                  </div>
                  <form className="ml-auo space-y-4">
                    <input type='text' placeholder='Entrer votre nom'
                        className="w-full rounded-md py-3 px-4 bg-white text-sm transition-all duration-100 outline-none focus:box-border focus:border-2 focus:border-pink-600 poppins-regular" />
                    <input type='email' placeholder='Entrer votre adresse e-mail'
                        className="w-full rounded-md py-3 px-4 bg-white text-sm transition-all duration-100 outline-none focus:box-border focus:border-2 focus:border-pink-600 poppins-regular" />
                    <input type='text' placeholder='Entrer votre N° téléphone'
                        className="w-full rounded-md py-3 px-4 bg-white text-sm transition-all duration-100 outline-none focus:box-border focus:border-2 focus:border-pink-600 poppins-regular" />
                    <textarea placeholder='Vous pouvez écrire ici' rows="6"
                        className="w-full rounded-md px-4 bg-white text-sm pt-3 transition-all duration-100 outline-none focus:box-border focus:border-2 focus:border-pink-600 poppins-regular"></textarea>
                    <button type='button'
                        className="text-white bg-pink-600 transition-all duration-300 hover:border hover:border-pink-600 hover:text-pink-600 hover:bg-transparent rounded-md px-4 py-2 w-full uppercase poppins-semibold">Envoyer</button>
                  </form>
              </div>
              </div>
            </div>
          </div>
        </div>
      </div>
  )
}

export default Contact
